/**
 * @GENERATED from Figma node 3638:51943
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SlideshowBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      d="M14.676 7.186h1.783v6.655h-1.783zM12.892 8.578h-1.784v5.263h1.784zM9.324 9.97H7.541v3.871h1.783z"
    />
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M1 2.784h22v1.784h-1.19v11a2.676 2.676 0 0 1-2.675 2.675h-3.369l1.22 2.927-.11.046H15.07l-1.239-2.973h-4.26l-1.239 2.973H6.53l-.11-.046 1.22-2.927H4.864a2.676 2.676 0 0 1-2.676-2.675v-11H1zm18.766 13.414a.9.9 0 0 0 .261-.63v-11H3.973v11a.89.89 0 0 0 .892.891h14.27a.9.9 0 0 0 .63-.26"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SlideshowBright);
export { ForwardRef as SlideshowBright };
